module.exports = __webpack_public_path__ + "img/image10.dd9b38b1.png";